import React, { useEffect, useState } from 'react'
import { ResponsiveContainer } from 'recharts'
import { Moment } from 'moment'
import Grid from '@material-ui/core/Grid'

import { ERRORS } from 'consts'
import { snackbar } from 'components'
import { useApiCall } from 'hooks'

import { GetDataUserByLevelResponse, ParametersDownload } from './types'
import { getUserByLevel } from './api'
import { CustomPieChart } from './CustomPieChart'

interface propsUsersStatus {
  startDate: Moment
  endDate: Moment
}

interface ChartData {
  name: string
  value: number
}

const UsersByLevel: React.FC<propsUsersStatus> = ({ startDate, endDate }) => {
  const [data, setData] = useState<ChartData[]>([])
  const [requestUsersTags] = useApiCall<ParametersDownload, GetDataUserByLevelResponse>(() =>
    getUserByLevel({ startDate, endDate }),
  )

  useEffect(() => {
    requestUsersTags({ startDate, endDate })
      .then(resp => {
        setData(resp.data.map(item => ({ ...item, name: String(item.name) })))
      })
      .catch(() => {
        setData([])
        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate])

  return (
    <Grid
      container
      item
      spacing={2}
      md={12}
      style={{
        background: '#fff',
        boxShadow: '0 2px 7px 0 rgba(0,0,0,.06)',
        paddingTop: 20,
        paddingBottom: 20,
      }}
    >
      {/* <Grid item sm={12}> */}
      <ResponsiveContainer width="100%">
        <CustomPieChart data={data} title="" widthParam={650} cx={270} />
      </ResponsiveContainer>
      {/* </Grid> */}
    </Grid>
  )
}
export { UsersByLevel }
